module.exports = __webpack_public_path__ + "static/img/transport.6265413f.png";